import React from 'react'
import styled from '@emotion/styled'
import theme from '../../global/theme'

const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: ${theme.colors.contrastSecondary};
  color: ${theme.colors.secondary};
  padding: 5px;
  font-size: 12px;
  text-align: center;
  z-index: 1000;
`

const EnrollmentNotificationBanner = () => {
  return (
    <Container>
      Since you submitted your application for a Medicare Supplement (Medigap)
      plan, some functionality may be limited.
    </Container>
  )
}

export default EnrollmentNotificationBanner
